import { Alert, AlertTitle, Backdrop, Box, Button, CircularProgress, Fade, Grid, MenuItem, Modal, Slide, Snackbar, Stack, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { PriceListGrid } from "../../../components/pagination_view";
import BrowserUpdatedOutlinedIcon from '@mui/icons-material/BrowserUpdatedOutlined';
import { CreateNewPriceList, PriceLists } from "../../../services/admin_service";

const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.screen.width / 1.5,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 1,
    p: 4,
};

const SlideTransition = (props) => {
    return <Slide {...props} direction="left" />;
}

const listData = (code, service_name, rate_type, rate, afternoon_rate, night_rate, saturday_rate, sunday_rate, public_holiday_rate) => {
    return {
        code,
        service_name,
        rate_type,
        rate,
        afternoon_rate,
        night_rate,
        saturday_rate,
        sunday_rate,
        public_holiday_rate
    };
};

const headCells = [
    {
        id: 'Id',
        numeric: false,
        disablePadding: true,
        label: 'Id',
    },
    {
        id: 'Code',
        numeric: false,
        disablePadding: true,
        label: 'Code',
    },
    {
        id: 'Service Name',
        numeric: false,
        disablePadding: true,
        label: 'Service Name',
    },
    {
        id: 'Rate Type',
        numeric: true,
        disablePadding: false,
        label: 'Rate Type',
    },
    {
        id: 'Rate',
        numeric: true,
        disablePadding: false,
        label: 'Rate',
    },
    {
        id: 'Afternoon Rate',
        numeric: true,
        disablePadding: false,
        label: 'Afternoon Rate',
    },
    {
        id: 'Night Rate',
        numeric: true,
        disablePadding: false,
        label: 'Night Rate',
    },
    {
        id: 'Saturday Rate',
        numeric: true,
        disablePadding: false,
        label: 'Saturday Rate',
    },
    {
        id: 'Sunday Rate',
        numeric: true,
        disablePadding: false,
        label: 'Sunday Rate',
    },
    {
        id: 'Public Holiday Rate',
        numeric: true,
        disablePadding: false,
        label: 'Public Holiday Rate',
    },
    {
        id: 'Options',
        numeric: true,
        disablePadding: false,
        label: 'Options',
    },
];

export const PriceList = () => {
    // const navigate = useNavigate();
    const height = window.screen.height;
    const width = () => {
        if (window.screen.width > 1600) {
            return window.screen.width / 5
        }
        if (window.screen.width > 600 && window.screen.width < 1600) {
            return window.screen.width / 4
        } else {
            return window.screen.width / 1.3
        }
    }
    const [screenWidth, setScreenWidth] = useState(width);
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => setOpen(true);

    const [price_list, loading_list] = PriceLists();
    const [priceList, createData, loading, error] = CreateNewPriceList();

    const [snacks, setSnack] = useState({
        open: false,
        Transition: SlideTransition,
        vertical: 'top',
        horizontal: 'right',
    });

    const [errorSnackMessage, setErrorSnackMessage] = useState({
        title: "",
        message: "",
        severity: "",
        variant: "filled"
    });

    useEffect(() => {
        if (window.screen) {
            setScreenWidth(width);
        }
    }, [window.screen])

    const [newList, setNewList] = useState([
        {
            title: "Code",
            value: "",
            placeholder: "",
            width: screenWidth,
            type: "text",
            required: true,
            multiline: false,
        },
        {
            title: "Service Name",
            value: "",
            placeholder: "",
            width: screenWidth,
            type: "text",
            required: true,
            multiline: true,
        },
        {
            title: "Rate Type",
            value: "Hourly Rate",
            type: "drop_down",
            width: screenWidth,
            required: true,
            options: [
                {
                    title: "Hourly Rate",
                    selected: true
                },
                {
                    title: "Fixed Rate",
                    selected: false
                },
                {
                    title: "Perday Rate",
                    selected: false
                },
                {
                    title: "Hourly Rate - Apportion",
                    selected: false
                },
                {
                    title: "Fixed Rate - Apportion",
                    selected: false
                },
            ]
        },
        {
            title: "Rate",
            value: "",
            width: screenWidth,
            type: "number",
            required: true,
            multiline: false,
        },
        {
            title: "Afternoon Rate",
            value: "",
            width: screenWidth,
            type: "number",
            required: true,
            multiline: false,
        },
        {
            title: "Night Rate",
            value: "",
            width: screenWidth,
            type: "number",
            required: true,
            multiline: false,
        },
        {
            title: "Saturday Rate",
            value: "",
            width: screenWidth,
            type: "number",
            required: true,
            multiline: false,
        },
        {
            title: "Sunday Rate",
            value: "",
            width: screenWidth,
            type: "number",
            required: true,
            multiline: false,
        },
        {
            title: "Public Holiday Rate",
            value: "",
            width: screenWidth,
            type: "number",
            required: true,
            multiline: false,
        },
    ]);

    const [rows, setRows] = useState([]);

    const editPriceItem = (id) => {
        const rowList = [...rows];
        const ListItem = rowList[id];
        const copy = [...newList]
        for (const key in copy) {
            copy[key].value = ListItem[copy[key].title.toLowerCase().split(" ").join("_")]
        }
        setNewList(copy);
        setOpen(true);
    }

    const editPriceItemEmpty = () => {
        const copy = [...newList];
        for (const key in copy) {
            copy[key].value = "";
        }
        setOpen(false);
        setNewList(copy);
    }

    const createNewPriceListQuery = async (obj) => {
        try {
            const response = await priceList({
                variables: obj
            })
            setSnack({
                ...snacks,
                open: true,
            });
            if (response?.data) {
                setErrorSnackMessage({
                    ...errorSnackMessage,
                    title: response?.data?.createPriceList?.data?.attributes?.service_name,
                    message: "New Price List Created.!",
                    severity: "success"
                })
                editPriceItemEmpty()
            } else {
                throw response
            }
        } catch (error) {
            console.log(error)
            setErrorSnackMessage({
                ...errorSnackMessage,
                title: error?.response?.data?.error?.name,
                message: error?.response?.data?.error?.message,
                severity: "error"
            })
        }
    }

    const saveItem = () => {
        const copy = [...newList];
        const obj = {
            code: copy[0].value,
            service_name: copy[1].value,
            rate_type: copy[2].value.replace(/ /g, "_"),
            rate: Number(copy[3].value),
            afternoon_rate: Number(copy[4].value),
            night_rate: Number(copy[5].value),
            saturday_rate: Number(copy[6].value),
            sunday_rate: Number(copy[7].value),
            public_holiday_rate: Number(copy[8].value),
        }
        createNewPriceListQuery(obj)
    }

    useEffect(() => {
        if (price_list) {
            const list = [];
            for (const key in price_list) {
                list.push({
                    id: Number(key) + 1,
                    code: price_list[key]?.attributes?.code,
                    service_name: price_list[key]?.attributes?.service_name,
                    rate_type: price_list[key]?.attributes?.Rate_Type?.replace(/_/g, " "),
                    rate: price_list[key]?.attributes?.rate,
                    afternoon_rate: price_list[key]?.attributes?.afternoon_rate,
                    night_rate: price_list[key]?.attributes?.night_rate,
                    saturday_rate: price_list[key]?.attributes?.saturday_rate,
                    sunday_rate: price_list[key]?.attributes?.sunday_rate,
                    public_holiday_rate: price_list[key]?.attributes?.public_holiday_rate,
                })
            }
            setRows(list);
        }
    }, [price_list])

    const handleCloseSnacks = () => {
        setSnack({
            ...snacks,
            open: false,
        });
    };

    return (
        <Grid container sx={{ py: 2, display: "flex", justifyContent: "center", }}>
            <Grid item={true} xs={11.5} sm={12} md={11} lg={11} sx={{ display: "flex", justifyContent: "flex-end", }}>
                <Stack direction="row" spacing={2}>
                    <Button onClick={handleOpen} variant="outlined" sx={{ bgcolor: "#ffffff", fontFamily: "Roboto-Medium", textTransform: "capitalize", color: "#000000", border: "2px solid #6ECA35", ":hover": { border: "2px solid #6ECA35", } }}>
                        Create
                    </Button>
                    <Button startIcon={<BrowserUpdatedOutlinedIcon color="primary" />} variant="outlined" sx={{ bgcolor: "#ffffff", fontFamily: "Roboto-Medium", textTransform: "capitalize", color: "#000000", border: "2px solid #6ECA35", ":hover": { border: "2px solid #6ECA35", } }}>
                        Import
                    </Button>
                </Stack>
            </Grid>
            <Grid item={true} xs={11.5} sm={12} md={11} lg={11} sx={{ my: 1, }}>
                {rows.length ? <PriceListGrid headCells={headCells} rows={rows} editPriceItem={editPriceItem} /> : <>
                    {loading_list ? (
                        <Box
                            sx={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                            }}
                        >
                            <CircularProgress color="secondary" size={50} />
                        </Box>
                    ) : null}
                </>}
            </Grid>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Box>
                            <Typography color={"primary"} sx={{ fontFamily: "Roboto-Bold", fontSize: "1.5em" }}>
                                Create Price List
                            </Typography>
                        </Box>
                        <Box sx={{ py: 2, }}>
                            {newList.map((v, i) => {
                                if (v.type === "text" || v.type === "number") {
                                    return (
                                        <TextField
                                            type={v.type}
                                            multiline={v.multiline}
                                            key={i}
                                            required={v.required}
                                            label={v.title}
                                            htmlFor={v.title}
                                            value={v.value}
                                            sx={{ m: 1, width: v.width }}
                                            onChange={(e) => {
                                                const copy = [...newList];
                                                copy[i].value = e.target.value;
                                                setNewList(copy);
                                            }}
                                        />
                                    )
                                }
                                if (v.type === "drop_down") {
                                    return (
                                        <TextField
                                            select={true}
                                            label={v.title}
                                            htmlFor={v.title}
                                            key={i}
                                            required={v.required}
                                            sx={{ m: 1, width: v.width }}
                                            value={v.value}
                                            // helperText={"Please select your " + v.title}
                                            onChange={(e) => {
                                                const copy = [...newList];
                                                copy[i].value = e.target.value;
                                                setNewList(copy);
                                            }}
                                        >
                                            {v?.options?.map((option) => (
                                                <MenuItem key={option.title} value={option.title}>
                                                    {option.title}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )
                                }
                            })}
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", px: 3 }}>
                            <Stack direction="row" spacing={2}>
                                <Button onClick={() => saveItem()} variant="outlined" sx={{ bgcolor: "#ffffff", fontFamily: "Roboto-Medium", textTransform: "capitalize", color: "#000000", border: "2px solid #6ECA35", ":hover": { border: "2px solid #6ECA35", } }}>
                                    Save {loading ? <CircularProgress color="secondary" size={26} /> : null}
                                </Button>
                                <Button onClick={() => editPriceItemEmpty()} variant="outlined" sx={{ bgcolor: "#ffffff", fontFamily: "Roboto-Medium", textTransform: "capitalize", color: "#000000", border: "2px solid #6ECA35", ":hover": { border: "2px solid #6ECA35", } }}>
                                    Cancel
                                </Button>
                            </Stack>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
            {/* messages */}
            <Snackbar open={snacks.open} autoHideDuration={3000} onClose={handleCloseSnacks} TransitionComponent={snacks.Transition} anchorOrigin={{ vertical: snacks.vertical, horizontal: snacks.horizontal }}>
                <Alert
                    onClose={handleCloseSnacks}
                    severity={errorSnackMessage.severity}
                    variant={errorSnackMessage.variant}
                    sx={{ width: '100%' }}
                >
                    <AlertTitle>{errorSnackMessage.title}</AlertTitle>
                    {errorSnackMessage.message}
                </Alert>
            </Snackbar>
        </Grid>
    )
}